import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { WithAvailabilityBlockId } from '@mews-commander/types';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { ConnectedEditDialogForm } from '@mews-commander/legacy-form';
import { updateAvailabilityBlockReleasedUtc } from '../../../actions/formActions';
import { useAvailabilityBlock } from '../../../utils/useAvailabilityBlock';
import { EditDialog } from '../../../enums';
import { getReleasedDateInitialValues } from '../../../selectors';
import { ReleasedDateContent, ReleasedDateFormValues } from './ReleasedDateContent';

const formId = EditDialog.ReleasedDateForm;

interface ReleaseDateDialogProps extends WithAvailabilityBlockId {
    onClose: () => void;
}

export const ReleaseDateDialog: React.FC<ReleaseDateDialogProps> = ({ onClose, availabilityBlockId }) => {
    const dispatch = useCommanderThunkDispatch();
    const availabilityBlock = useAvailabilityBlock(availabilityBlockId);
    const initialValues = useCommanderSelector((state) =>
        getReleasedDateInitialValues(state, { id: availabilityBlockId })
    );

    if (!availabilityBlock) {
        return null;
    }

    const onSubmit = async (values: ReleasedDateFormValues) => {
        // eslint-disable-next-line @typescript-eslint/await-thenable
        await dispatch(updateAvailabilityBlockReleasedUtc(values, availabilityBlockId, availabilityBlock.serviceId));
        onClose();
    };
    return (
        <ConnectedEditDialogForm
            active
            closeDialog={onClose}
            formName={formId}
            title={<LocalizedText textKey={TextKey.ReleaseDate} />}
        >
            <ReleasedDateContent
                availabilityBlockId={availabilityBlockId}
                form={formId}
                initialValues={initialValues}
                onSubmit={onSubmit}
            />
        </ConnectedEditDialogForm>
    );
};
